var WelcomeSplashService = /** @class */ (function () {
    function WelcomeSplashService($http, $q) {
        'ngInject';
        this.splashPageData = null;
        this.hasBeenSeen = false; // boolean denoting whether the welcome splash dialog has been viewed
        this.$http = $http;
        this.$q = $q;
    }
    WelcomeSplashService.prototype.getWelcomeSplashContent = function () {
        var _this = this;
        return this.$http.get('api/content/splashPage/eeRedesignWelcomeSplash')
            .then(function (response) {
            _this.splashPageData = response.data.response;
            return _this.splashPageData;
        })
            .catch(function (reason) {
            return _this.$q.reject(reason);
        });
    };
    WelcomeSplashService.prototype.dontShowAgain = function () {
        var _this = this;
        return this.$http.post('api/content/splashPage/insertOrUpdate', { splashPageId: this.splashPageData.splashPageId, show: false })
            .then(function (response) {
            return response.data.response;
        })
            .catch(function (reason) {
            return _this.$q.reject(reason);
        });
    };
    return WelcomeSplashService;
}());
export { WelcomeSplashService };
//# sourceMappingURL=welcome-splash.service.js.map